export const ApplicationModuleGroups = {
  CP: 2,
  PIROWeb: 3,
  WebPOS: 5,
  SPIFF: 6
}
